<template>
<div class="about_menu_top  textalign_left">    
    <div style="background: #fff;max-width: 1920px;margin: 0 auto;"  class="ms-controller">
        <div style="margin: 0 auto;">
            <div style="height: 600px;background: url('http://p1.fishqc.net/Fpo1QEmjMaZbIwLmOvHXuURp19hC') center center no-repeat;background-size: auto 100%;">
                <div style="width: 1000px;margin:0 auto;display: block;text-align: center;padding-top: 500px;">
                    <img src="http://p1.fishqc.net/FsWqUWI05_AA8Kt2FbOVcmFRByCA" class="img_center">
                </div>
                
            </div>
            
            <div style="height: 9000px;background: url('http://p1.fishqc.net/FrQzc1XcF5tm2RftpsJG3WJx51ll') center center no-repeat;background-size: auto 100%;">
                <div class="mumcontain">
                    
                   <img src="http://p1.fishqc.net/FoJw0N_Oufwu41kPw-F0VmBoyhiP" class="img_center" style="padding-top: 100px;box-sizing:border-box;">
                   <div class="productbox1">
                       <div class="babel1">美肌食品</div>
                       <div  class="icon_position">
                        <img src="http://p1.fishqc.net/FqdSrLaFPq3Z9wfW256a0X_E0g6n" class="icon">
                        <img src="http://p1.fishqc.net/Fuu31ZUiC2539A7Qd2Jw2PJSR_FL" class="icon">
                        <img src="http://p1.fishqc.net/FuPXGFvNmXofBXHNiM6D1klCYh_C" class="icon">
                       </div>
                       <div class="content">护肤可不能忽略内在，内服外调事半功倍，针对功效搭配更是关键，科学测评功效显著内服美肤好物，吃出健康好肌肤。</div>
                       
                           <div class="display_flex justify-content_flex-justify flex-wrap_wrap padding_20 margin_top_50" style="margin-top: 36px;">
                                <div class="productcontent" @click="toproductdetail('food','Uedu1Vc8wDthQoW1PC1hpA')">
                                    <div class="productImg">
                                        <img src="http://p1.fishqc.net/Fi8E4k3t5lB3xDMdiYD4OM_G8prj" class="imgcenter product1">
                                    </div>
                                    <div>
                                        <div class="productname">
                                            <div>VAUCH炎帝</div>
                                            <div>葛仙米胶原蛋白果味饮料</div>
                                        </div>
                                        <div class="text_left">
                                            <img src="http://p1.fishqc.net/Fj5Lhw4EYmQ5tVb9z-Jz4pOYje4F" style="width:178px;height:22px;margin-top: 5px;">
                                        </div>
                                        <div class="display_flex justify-content_flex-justify padding_right_30">
                                            <div class="productaddress">品牌所在地：中国</div>
                                            <img src="http://p1.fishqc.net/FuXQ_0mi2n-o0Q6WifovDGA8MBQ1" class="productlabel1">
                                        </div>
                                        
                                    </div>
                                </div>
                                <div class="productcontent" @click="toproductdetail('food','6_Cp682RO08-G9JngiFewA')">
                                    <div class="productImg">
                                        <img src="http://p1.fishqc.net/Fvrf8TbtmOatHW0_T5IV40w-PL5I" class="imgcenter product2">
                                    </div>
                                    <div>
                                        <div class="productname">
                                            <div>JIAO QU胶趣 </div>
                                            <div>鲜炖红枣花胶</div>
                                        </div>
                                        <div class="text_left">
                                            <img src="http://p1.fishqc.net/FpK5bIE9n8LqXF5w9mnz6MFgMdbD" style="width:145px;height:22px;margin-top: 5px;">
                                        </div>
                                        <div class="display_flex justify-content_flex-justify padding_right_30">
                                            <div class="productaddress">品牌所在地：中国</div>
                                            <img src="http://p1.fishqc.net/FsOaI4rjzoFLaTPeDOnI7tW123af" class="productlabel1">
                                        </div>
                                        
                                    </div>
                                </div>
                           </div>
                           <div class="display_flex justify-content_flex-justify flex-wrap_wrap padding_20 margin_top_70">
                                <div class="productcontent" @click="toproductdetail('cosmetic','lj8t4ZzijnvFvWXn31pp4g')">
                                    <div class="productImg">
                                        <img src="http://p1.fishqc.net/FoUiwPt9AtLu9DorXYkpngVcLBpt" class="imgcenter product3">
                                    </div>
                                    <div>
                                        <div class="productname">
                                            <div>LADY'S BISHOH美翔  </div>
                                            <div>乳酸菌胶原蛋白口服液</div>
                                        </div>
                                        <div class="text_left">
                                            <div class="product_effcncy">美白功效显著</div>
                                        </div>
                                        <div class="display_flex justify-content_flex-justify padding_right_30">
                                            <div class="productaddress">品牌所在地：日本</div>
                                            <img src="http://p1.fishqc.net/Fusr0v5avqGguNMHTjnSeQFgc6JV" class="productlabel1">
                                        </div>
                                        
                                    </div>
                                </div>
                                <div class="productcontent" @click="toproductdetail('cosmetic','PBUfp_gTUElgaFdl2BpCNQ')">
                                    <div class="productImg">
                                        <img src="http://p1.fishqc.net/Fpf1I7IaZHvDspp5Euy8oWlzDCjr" class="imgcenter product4">
                                    </div>
                                    <div>
                                        <div class="productname">
                                            <div>VIERRA惟爱论 </div>
                                            <div>美白片</div>
                                        </div>
                                        <div class="text_left">
                                            <div class="product_effcncy">美白功效显著</div>
                                        </div>
                                        <div class="display_flex justify-content_flex-justify padding_right_30">
                                            <div class="productaddress">品牌所在地：澳洲</div>
                                            <img src="http://p1.fishqc.net/FvCvLx6nk-Fza6532Lsg5L1Nb4PQ" class="productlabel1">
                                        </div>
                                        
                                    </div>
                                </div>
                           </div>
                       
                   </div>
                   <div class="productbox2" style="margin-top: 90px;">
                       <div class="babel1">美白面膜</div>
                       <div  class="icon_position1">
                        <img src="http://p1.fishqc.net/Fuu31ZUiC2539A7Qd2Jw2PJSR_FL" class="icon">
                       </div>
                       <div class="content" style="margin-top: 80px;">美白是每个夏天的热门话题，护肤必备的面膜可以快速补水软化角质， 美白功效显著的面膜更能获得精致女孩们的青睐。</div>
                       
                           <div class="display_flex justify-content_flex-justify flex-wrap_wrap padding_20 margin_top_50" style="margin-top: 30px;">
                                <div class="productcontent" @click="toproductdetail('cosmetic','Jto1Lma5F8oKLc74DgSIFA')">
                                    <div class="productImg">
                                        <img src="http://p1.fishqc.net/FspzKViPmC7u-CDYcHlwto7N0uwE" class="imgcenter product5">
                                    </div>
                                    <div>
                                        <div class="productname">
                                            <div>AHC</div>
                                            <div>臻致维生素C面膜（天然纤维）</div>
                                        </div>
                                        <div class="text_left">
                                            <div class="product_effcncy">美白功效显著</div>
                                        </div>
                                        <div class="display_flex justify-content_flex-justify padding_right_30">
                                            <div class="productaddress">品牌所在地：韩国</div>
                                            <img src="http://p1.fishqc.net/Fhum4CQtDWox2YFxXE_I48xYpFHX" class="productlabel1">
                                        </div>
                                        
                                    </div>
                                </div>
                                <div class="productcontent" @click="toproductdetail('cosmetic','NaUu6N7u3-d3XrAkE55HHw')">
                                    <div class="productImg">
                                        <img src="http://p1.fishqc.net/FnGcS6V1JrDCAJ6si2zkNQyp0djO" class="imgcenter product6">
                                    </div>
                                    <div>
                                        <div class="productname">
                                            <div>JAYJUN捷俊 </div>
                                            <div>黑色水光面膜三部曲</div>
                                        </div>
                                        <div class="text_left">
                                            <div class="product_effcncy">美白功效显著</div>
                                        </div>
                                        <div class="display_flex justify-content_flex-justify padding_right_30">
                                            <div class="productaddress">品牌所在地：韩国</div>
                                            <img src="http://p1.fishqc.net/FkPCT9UradW70_0AAXr69ZcbTNyp" class="productlabel1">
                                        </div>
                                        
                                    </div>
                                </div>
                           </div>
                   </div>
                   <div class="productbox2" style="margin-top: 90px;">
                       <div class="babel1">抗衰老精华</div>
                       <div  class="icon_position1">
                        <img src="http://p1.fishqc.net/FuPXGFvNmXofBXHNiM6D1klCYh_C" class="icon">
                       </div>
                       <div class="content" style="margin-top: 80px;">深层抗老要趁早，安全抗衰产品很重要。精华渗入基底层发挥作用，选择抗衰老功效显著精华，保持年轻肌肤。</div>
                       
                           <div class="display_flex justify-content_flex-justify flex-wrap_wrap padding_20 margin_top_50" style="margin-top: 30px;">
                                <div class="productcontent" @click="toproductdetail('cosmetic','T3MZc1NnmmJ6BO-pSDYTCg')">
                                    <div class="productImg">
                                        <img src="http://p1.fishqc.net/FoyFCYq3iiThpgI0gf5LIBpa6GEB" class="imgcenter product7">
                                    </div>
                                    <div>
                                        <div class="productname">
                                            <div>L'ORÉAL PARIS巴黎欧莱雅 </div>
                                            <div style="font-size: 18px;">复颜抗皱紧致视黄醇精粹抗皱精华</div>
                                        </div>
                                        <div class="text_left">
                                            <div class="product_effcncy">抗衰老功效显著</div>
                                        </div>
                                        <div class="display_flex justify-content_flex-justify padding_right_30">
                                            <div class="productaddress">品牌所在地：法国</div>
                                            <img src="http://p1.fishqc.net/Fjha2AGwOK5njRyR4tOHSs_k3n7d" class="productlabel1">
                                        </div>
                                        
                                    </div>
                                </div>
                                <div class="productcontent" @click="toproductdetail('cosmetic','fp6PX4zBtebjsVX7GxgoPA')">
                                    <div class="productImg">
                                        <img src="http://p1.fishqc.net/FtTU6T6DAEa3Cl1bbtydvmp9re3O" class="imgcenter product8">
                                    </div>
                                    <div>
                                        <div class="productname">
                                            <div>SHISEIDO资生堂  </div>
                                            <div>新透白美肌集光袪斑精华液</div>
                                        </div>
                                        <div class="text_left">
                                            <div class="product_effcncy">抗衰老功效显著</div>
                                        </div>
                                        <div class="display_flex justify-content_flex-justify padding_right_30">
                                            <div class="productaddress">品牌所在地：日本</div>
                                            <img src="http://p1.fishqc.net/FqDnr6DvorSGOJF2MzmFplI2d8-j" class="productlabel1">
                                        </div>
                                        
                                    </div>
                                </div>
                           </div>
                   </div>
                   <div class="productbox2" style="margin-top: 90px;">
                       <div class="babel1">舒缓身体乳</div>
                       <div  class="icon_position1">
                        <img src="http://p1.fishqc.net/FgyCgSF4piDf_pun464VgLkyfPo6" class="icon">
                       </div>
                       <div class="content" style="margin-top: 80px;">夏日高温潮湿，容易诱发皮肤炎症，加上空调房湿度低，皮肤干燥，更需要选择舒缓功效显著的身体乳做好身体护理。</div>
                       
                           <div class="display_flex justify-content_flex-justify flex-wrap_wrap padding_20 margin_top_50" style="margin-top: 30px;">
                                <div class="productcontent" @click="toproductdetail('cosmetic','G8DSWGQVu9-PBfLpFkvDiA')">
                                    <div class="productImg">
                                        <img src="http://p1.fishqc.net/Fu-FLq_PhwyCbsunOC7r4HI-sRri" class="imgcenter product8">
                                    </div>
                                    <div>
                                        <div class="productname">
                                            <div>CeraVe  </div>
                                            <div>长效保湿修复乳</div>
                                        </div>
                                        <div class="text_left">
                                            <div class="product_effcncy">舒缓功效显著</div>
                                        </div>
                                        <div class="display_flex justify-content_flex-justify padding_right_30">
                                            <div class="productaddress">品牌所在地：法国</div>
                                            <img src="http://p1.fishqc.net/FkF1YefK1Zypl9PtTQZiRNzjbhdE" class="productlabel1">
                                        </div>
                                        
                                    </div>
                                </div>
                                <div class="productcontent" @click="toproductdetail('cosmetic','syRVqfvDqCizUwkg0irO1w')">
                                    <div class="productImg">
                                        <img src="http://p1.fishqc.net/FhoclE-49ULNSQW7QkbVzTyGDFK9" class="imgcenter product9">
                                    </div>
                                    <div>
                                        <div class="productname">
                                            <div>NIVEA妮维雅 </div>
                                            <div>深层润肤乳液</div>
                                        </div>
                                        <div class="text_left">
                                            <div class="product_effcncy">舒缓功效显著</div>
                                        </div>
                                        <div class="display_flex justify-content_flex-justify padding_right_30">
                                            <div class="productaddress">品牌所在地：德国</div>
                                            <img src="http://p1.fishqc.net/Fjr6nF1ZPs_8lbqvNZmRb_S3rYt5" class="productlabel1">
                                        </div>
                                        
                                    </div>
                                </div>
                           </div>
                   </div>
                   <img src="http://p1.fishqc.net/Fkgk8ujPKWYchIuqD9i-IKfSVZBI" class="img_center margin_top_106">

                   <div class="productbox2" style="margin-top: 54px;height: 377px;">
                       <div class="babel1">儿童零食</div>
                     
                       <div class="content1">小鱼亲测数据库中，大部分不达标零食产品均是类雌激素过高，容易导致性早熟，智商降低，癌症等，选绿鱼的才放心。</div>
                       
                           <div class="display_flex justify-content_flex-justify flex-wrap_wrap padding_20 margin_top_50" style="margin-top: 30px;">
                                <div class="productcontent" @click="toproductdetail('food','AQOm0_dBTftybNGUusasrw')">
                                    <div class="productImg">
                                        <img src="http://p1.fishqc.net/FgiXXN8P0dGJnae6FSbYyb943kQX" class="imgcenter product10">
                                        <img src="http://p1.fishqc.net/FkzKbrdBmFZGNqYYqmP3P9Cls_WG" class="product_greenicon">
                                    </div>
                                    <div>
                                        <div class="productname">
                                            <div>米小芽  </div>
                                            <div>香香的鲜脆虾片</div>
                                        </div>
                                        <div class="display_flex justify-content_flex-justify padding_right_30 padding-top-22">
                                            <div class="productaddress">品牌所在地：中国</div>
                                            <img src="http://p1.fishqc.net/Fos9VKxYTfcWLWvm3xyWDCTckEbp" class="productlabel1">
                                        </div>
                                        
                                    </div>
                                </div>
                                <div class="productcontent" @click="toproductdetail('food','ns5hZxNaa1movHgBKKhplw')">
                                    <div class="productImg">
                                        <img src="http://p1.fishqc.net/FiR2LBONC_OPZ5q_YxOa8OrmTJ6A" class="imgcenter product11">
                                        <img src="http://p1.fishqc.net/FkzKbrdBmFZGNqYYqmP3P9Cls_WG" class="product_greenicon">
                                    </div>
                                    <div>
                                        <div class="productname">
                                            <div>GOOD GOÛT  </div>
                                            <div>榛子巧克力夹心米饼</div>
                                        </div>
                                        <div class="display_flex justify-content_flex-justify padding_right_30 padding-top-22">
                                            <div class="productaddress">品牌所在地：法国</div>
                                            <img src="http://p1.fishqc.net/Fqcc_-rzRxihfG4KViJEHsBpGWjS" class="productlabel1">
                                        </div>
                                        
                                    </div>
                                </div>
                           </div>


                   </div>
                    
                    <div class="productbox2" style="margin-top: 46px;height: 377px;">
                       <div class="babel1">保健食品</div>
                     
                       <div class="content1">人体需要的营养素很多，除了三餐外还需要根据身体情况补充营养。琳琅满目怎么选？想要健康有保障，跟着小鱼榜单选。</div>
                       
                           <div class="display_flex justify-content_flex-justify flex-wrap_wrap padding_20 margin_top_50" style="margin-top: 30px;">
                                <div class="productcontent"  @click="toproductdetail('food','wSBCwDwlva8v9AkRVIx8OQ')">
                                    <div class="productImg">
                                        <img src="http://p1.fishqc.net/Fts9sIkEIbfPe7p4s91_aBKhJnzE" class="imgcenter product12">
                                        <img src="http://p1.fishqc.net/FkzKbrdBmFZGNqYYqmP3P9Cls_WG" class="product_greenicon">
                                    </div>
                                    <div>
                                        <div class="productname">
                                            <div>SWISSE  </div>
                                            <div>ULTIBOOST 维他命 D</div>
                                        </div>
                                        <div class="display_flex justify-content_flex-justify padding_right_30 padding-top-22" style="padding-right:20px;">
                                            <div class="productaddress">品牌所在地：澳大利亚</div>
                                            <img src="http://p1.fishqc.net/Fov1JYoY1X-qtCVhrImmyGP2kHFR" class="productlabel1">
                                        </div>
                                        
                                    </div>
                                </div>
                                <div class="productcontent" @click="toproductdetail('food','yIO8Zliupd7oMIl6hXA_yg')">
                                    <div class="productImg">
                                        <img src="http://p1.fishqc.net/FizfTj-MgMcUSLdvfFqKuNlbE2HV" class="imgcenter product13">
                                        <img src="http://p1.fishqc.net/FkzKbrdBmFZGNqYYqmP3P9Cls_WG" class="product_greenicon">
                                    </div>
                                    <div>
                                        <div class="productname">
                                            <div>GNC健安喜   </div>
                                            <div>高含量钙片1000mg</div>
                                        </div>
                                        <div class="display_flex justify-content_flex-justify padding_right_30 padding-top-22">
                                            <div class="productaddress">品牌所在地：美国</div>
                                            <img src="http://p1.fishqc.net/FtCbXLOCIyqigeV4vj6xgBAMqejt" class="productlabel1">
                                        </div>
                                        
                                    </div>
                                </div>
                           </div>

                           
                   </div>
                   <div class="productbox2" style="margin-top: 46px;height: 377px;">
                       <div class="babel1">防晒</div>
                     
                       <div class="content1">夏天是日晒与紫外线最强的时候，不仅会引起皮肤损伤，黑色素沉着，更重要是使皮肤老化，夏日必备绿鱼防晒。</div>
                       
                           <div class="display_flex justify-content_flex-justify flex-wrap_wrap padding_20 margin_top_50" style="margin-top: 30px;">
                                <div class="productcontent" @click="toproductdetail('cosmetic','cB2FgmQEHHzA32fRRt1_Tw')">
                                    <div class="productImg">
                                        <img src="http://p1.fishqc.net/Fpqgu0NluuH7nQOjkV7xOb2Jedaz" class="imgcenter product14">
                                        <img src="http://p1.fishqc.net/FkzKbrdBmFZGNqYYqmP3P9Cls_WG" class="product_greenicon">
                                    </div>
                                    <div>
                                        <div class="productname">
                                            <div>ANESSA安热沙 </div>
                                            <div>金钻防晒露 SPF50+ PA++++</div>
                                        </div>
                                        <div class="display_flex justify-content_flex-justify padding_right_30 padding-top-22">
                                            <div class="productaddress">品牌所在地：日本</div>
                                            <img src="http://p1.fishqc.net/FsKZPlpiG7-EYxDQ5y7VYKJZ65cq" class="productlabel1">
                                        </div>
                                        
                                    </div>
                                </div>
                                <div class="productcontent" @click="toproductdetail('cosmetic','-3KwkJNVMQURNyropolQLA')">
                                    <div class="productImg">
                                        <img src="http://p1.fishqc.net/Fqqgp9K2W17C3ZIInFD22rKOf1LG" class="imgcenter product15">
                                        <img src="http://p1.fishqc.net/FkzKbrdBmFZGNqYYqmP3P9Cls_WG" class="product_greenicon">
                                    </div>
                                    <div>
                                        <div class="productname">
                                            <div>BIORE碧柔 Aqua Rich </div>
                                            <div>水凝長效保濕防曬乳 SPF50+</div>
                                        </div>
                                        <div class="display_flex justify-content_flex-justify padding_right_30 padding-top-22">
                                            <div class="productaddress">品牌所在地：日本</div>
                                            <img src="http://p1.fishqc.net/FpneBSjsFPlgpGWdkdCeyawrHjr2" class="productlabel1">
                                        </div>
                                        
                                    </div>
                                </div>
                           </div>

                           
                   </div>
                   <div class="productbox2" style="margin-top: 46px;height: 377px;">
                       <div class="babel1">驱蚊水</div>
                     
                       <div class="content1">夏天蚊虫多，驱蚊水必不可少，但劣质驱蚊水含有害成分，可能会有致畸、 致突变等危害，选择安全产品至关重要。</div>
                       
                           <div class="display_flex justify-content_flex-justify flex-wrap_wrap padding_20 margin_top_50" style="margin-top: 30px;">
                                <div class="productcontent" @click="toproductdetail('cosmetic','LymisJN0Nwy8H3O0ilf1aw')">
                                    <div class="productImg">
                                        <img src="http://p1.fishqc.net/Fl3uPePilu0fxnk7cZeWQL4227yu" class="imgcenter product16">
                                        <img src="http://p1.fishqc.net/FkzKbrdBmFZGNqYYqmP3P9Cls_WG" class="product_greenicon">
                                    </div>
                                    <div>
                                        <div class="productname">
                                            <div>DING DING日本叮叮 </div>
                                            <div>防敏蚊怕水</div>
                                        </div>
                                        <div class="display_flex justify-content_flex-justify padding_right_30 padding-top-22">
                                            <div class="productaddress">品牌所在地：香港</div>
                                            <img src="http://p1.fishqc.net/FrOLzJlRwzNHqRHl2JNhKE1NzEzt" class="productlabel1">
                                        </div>
                                        
                                    </div>
                                </div>
                                <div class="productcontent" @click="toproductdetail('cosmetic','uRz9F2TAdrYDM56MGox07A')">
                                    <div class="productImg">
                                        <img src="http://p1.fishqc.net/Fib2WMS62jL61fWc4eeGoicUUcyf" class="imgcenter product17">
                                        <img src="http://p1.fishqc.net/FkzKbrdBmFZGNqYYqmP3P9Cls_WG" class="product_greenicon">
                                    </div>
                                    <div>
                                        <div class="productname">
                                            <div>MENTHOLATUM曼秀雷敦 </div>
                                            <div>强效驱蚊喷雾</div>
                                        </div>
                                        <div class="display_flex justify-content_flex-justify padding_right_30 padding-top-22">
                                            <div class="productaddress">品牌所在地：美国</div>
                                            <img src="http://p1.fishqc.net/Fl5Op6wSZFzp_VZSM4wiP4zxGGoL" class="productlabel1">
                                        </div>
                                        
                                    </div>
                                </div>
                           </div>

                           
                   </div>

                </div>
                <div class="fixcontain">
                    <img src="http://p1.fishqc.net/FqCIrXR9wdKFjMhHMaswmHhsZTIb" class="img_center margin_top_100">
                    <img src="http://p1.fishqc.net/FkDFU2ZAMvmFRaTn9wh9RjEIVORB" class="img_center margin_top_50">
                    <img src="http://p1.fishqc.net/ForKBia9Evrt3nkhQBKkJ0NOKZZ-" class="img_center margin_top_50">
                    <img src="http://p1.fishqc.net/Fqw7wfoZX0boBtRSf5dNzbn9W4uW" class="img_center margin_top_32">
                    <img src="http://p1.fishqc.net/Fl3huuSNDqesHcjv5COATHOF0SPe" class="img_center margin_top_32">
                    <img src="http://p1.fishqc.net/FvpeJeEa-Fj1K_Kzhy3flScnPJji" class="img_center margin_top_20">
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
.about_menu_top {
    margin: 100px auto 0;

}
.fangyicontain {
    font-size: 0;
}

.techcover{
    padding-bottom:60px;
}

.listitem{
    padding:26px 26px 0px;
    box-sizing: border-box;
    font-size:18px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:32px;
    border:8px solid rgba(35, 181, 171, 1);
    border-radius:0px 24px 24px 24px;
    margin-bottom: 60px;
    background-color: #fff;
}

.listitem1{
    margin-bottom:48px;
}
.padding-bottom-24{
    padding-bottom:24px;
    box-sizing: border-box;
    text-align: left;
}

.productdetailcontain{
    flex:1;
    margin-right: 22px;
    display: inline-block;
    background-color: #fff;
    border-radius:24px;
    height: 255px;
    vertical-align: top;
    margin-bottom: 32px;
    cursor: pointer;
    border-radius:24px;
    box-shadow: 0 0 12px rgba(157,221,214,0.2);
    padding:25px 20px;
    box-sizing: border-box;

}
.flex-container{
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
}

.productdetailcontain:nth-of-type(2n){
    margin-right: 0px;
}

.imgcontain{
    width: 154px;
    height: 100%;
    display: inline-block;
    text-align:center;
    position: relative;
    overflow: hidden;
}
.center{
    position:absolute;
    left:50%;
    top:50%;
    transform: translate(-50%, -50%);
}
.greenfish{
    position:absolute;
    right:20px;
    bottom:10px;
}
.class1{
    width:190px;
    height:190px;
}
.class2{
    width:178px;
    height:178px;
}
.class3{
    width:190px;
    height:190px;
}
.class4{
    width:190px;
    height:190px;
}
.class5{
    width:190px;
    height:190px;
}
.class6{
    width:190px;
    height:190px;
}
.class7{
    width:190px;
    height:190px;
}
.class8{
    width:190px;
    height:190px;
}
.class9{
    width:190px;
    height:190px;
}
.class10{
    width:190px;
    height:190px;
}

.class11{
    width:190px;
    height:190px;
}
.class12{
   width:190px;
    height:190px;
}
.class13{
    height:190px;
    width:auto;
}
.class14{
    height:190px;
    width:auto;
}
.class15{
    width:190px;
    height:190px;
}
.class16{
    width:190px;
    height:190px;
}
.class17{
    width:190px;
    height:190px;
}
.class18{
    width:190px;
    height:190px;
}
.flex-one{
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
}
.brandcover{
    padding:10px 0 10px;
}

.band{
    
    font-size:24px;
    line-height: 26px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(80,79,75,1);
}

.title{
    font-size:18px;
    line-height: 18px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(80,79,75,1);
    padding-bottom: 22px;
}

.detail-tips{
    padding:0 12px;
    height:30px;
    background:rgba(210,242,238,1);
    border-radius:12px 0px 12px 0px;
    font-size:16px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(68,204,189,1);
    line-height: 30px;
    display:inline-block;
    text-align: center;

}
.address{
    padding-top: 30px;
    font-size:16px;
    line-height: 16px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(121,121,121,1);
}

.efficacyclass{
    width:131px;
    height:30px;
}

.efficacyclass1{
    width:149px;
    height:30px;
}

.relative618{
    position: relative;
    height: 70px;
}
.maintitle{
    height:70px;
    line-height: 70px;
    background:#23B5AB;
    border-radius:24px 24px 0px 0px;
    padding:0 30px;
    position: absolute;
    z-index: 2;
    bottom: 0;

}

.secondtitle{
    height:74px;
    line-height: 70px;
    background:#FFED5D;
    border-radius:24px 24px 0px 0px;
    padding:0 30px;
    position: absolute;
    bottom: 0px;
}
.relative618  .big{
    font-size:36px;
    font-family:Source Han Sans CN;
    font-weight:bold;
    color:rgba(255,255,255,1);
    margin-right: 20px;
}
.relative618  .small{
    font-size:28px;
    font-family:Source Han Sans CN;
    font-weight:400;
    color:rgba(255,255,255,1);
}

.firstarr:nth-of-type(3) .listitem .productdetailcontain:nth-of-type(1) .address{
    padding-top: 12px;
}
.relative618 .titleleft{
    left:0px;
}
.relative618 .secondtitleleft{
    left:4px;
}
.relative618 .titleright{
    right:0px;
}
.relative618 .secondtitleright{
    right:4px;
}

.border-radius-right{
    border-radius:24px 0px 24px 24px;
}
.display_flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
}

/*.display_flex > *{
     display: block;
 }*/
.display_inline-flex {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: -webkit-inline-flex;
    display: inline-flex;
}


/*伸縮流方向*/
.flex-direction_column {
    -webkit-box-orient: vertical;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
}

/*主軸對齊*/
.justify-content_flex-center {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
}

.justify-content_flex-end {
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
}

.justify-content_flex-justify {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
}

/*側軸對齊*/
.align-items_flex-start {
    -webkit-box-align: start;
    -ms-flex-align: start;
    -webkit-align-items: flex-start;
    align-items: flex-start;
}

.align-items_flex-end {
    -webkit-box-align: end;
    -ms-flex-align: end;
    -webkit-align-items: flex-end;
    align-items: flex-end;
}

.align-items_center {
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
}

.align-items_baseline {
    -webkit-box-align: baseline;
    -ms-flex-align: baseline;
    -webkit-align-items: baseline;
    align-items: baseline;
}

.align-items_space_between {
    -webkit-box-align: space-between;
    -ms-flex-align: space-between;
    -webkit-align-items: space-between;
    align-items: space-between;
}

.horizontal-between {
    justify-content: space-between;
    -webkit-justify-content: space-between;
}

/*伸縮性*/
.flex_auto {
    -webkit-box-flex: 1;
    -ms-flex: auto;
    -webkit-flex: auto;
    flex: auto;
}

.flex_1 {
    width: 0;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    -webkit-flex: 1;
    flex: 1;
}

.flex_2 {
    width: 0;
    -webkit-box-flex: 2;
    -ms-flex: 2;
    -webkit-flex: 2;
    flex: 2;
}


.flex-wrap_wrap {
    flex-wrap: wrap;
}


.padding-top-495 {
    padding-top: 495px;
}
.mumcontain{
    width: 1000px;
    margin:0 auto;
    display: block;
    text-align: center;
    padding-top: 0px;
    
}
.fixcontain{
    width: 1072px;
    margin:0 auto;
    display: block;
    text-align: center;
}
.img_center{
    text-align: center;
}

.productbox1{
    width: 1000px;
    height: 621px;
    background: #F2F9F8;
    border: 10px solid #DDDEFF;
    box-shadow: 0px 0px 10px 0px #59C4A8;
    border-radius: 24px;
    margin-top: 86px;
    position: relative;
    box-sizing: border-box
}
.productbox2{
    width: 1000px;
    height: 410px;
    background: #F2F9F8;
    border: 10px solid #DDDEFF;
    box-shadow: 0px 0px 10px 0px #59C4A8;
    border-radius: 24px;
    margin-top: 86px;
    position: relative;
    box-sizing: border-box
}
.babel1{
    width: 177px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    background: linear-gradient(0deg, #7C64E0, #AC49D9);
    border-radius: 0px 0px 36px 36px;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    position: absolute;
    top:-10px;
    left:50%;
    transform: translate(-50%,0);
}
.padding_20{
    padding:0 20px;
    box-sizing: border-box
}
.content{
    width: 704px;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #504F4B;
    line-height: 43px;
    text-align: center;
    margin:80px auto 0;
}
.content1{
    width: 704px;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #504F4B;
    line-height: 43px;
    text-align: center;
    margin:45px auto 0;
}
.productcontent{
    width: 457px;
    height: 162px;
    background: #FFFFFF;
    border-radius: 15px;
    padding-left: 150px;
    box-sizing: border-box;
    position:relative;
    cursor: pointer;
}
.productImg{
    width: 150px;
    height: 100%;
    position:absolute;
    display: inline-block;
    left:0;
    top:0;
}
.imgcenter{
    position: absolute;
    left:50%;
    top:50%;
    transform: translate(-50%,-50%);
}
.productname{
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #504F4B;
    line-height: 30px;
    text-align:left;
    padding-top: 20px;
    box-sizing: border-box
}

.product1{
    width: 89px;
    height: 82px;
}
.productlabel1{
    width: 105px;
    height: 29px;
}
.productaddress{
    font-size: 17px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #504F4B;
    line-height: 32px;
    text-align: left;
}

.padding_right_30{
    padding-right: 30px;
    box-sizing: border-box;
    padding-top:5px;
}
.padding-top-22{
    padding-top:22px;
    box-sizing: border-box
}
.product_effcncy{
    padding:6px 20px 6px  6px;
    box-sizing: border-box;
    background-color:#429AA5;
    color:#fff;
    font-size: 11px;
    line-height: 11px;
    display: inline-block;
    
    margin-top:5px;
    position: relative;
}
.product_effcncy:after{
    content: '';
    position: absolute;
    width: 24px;
    height: 24px;
    background-image: url(http://p1.fishqc.net/FujtO5kFbA_ovum4FQIsxSQBvCVN);
    background-repeat: no-repeat;
    background-position: center right;
    background-size: 23px 23px;
    top: -1px;
    right: -8px;
}

.text_left{
    text-align: left;
}
.margin_top_70{
    margin-top: 40px;
}

.margin_top_50{
    margin-top: 26px;
}
.product2{
    width:59px;
    height: 76px;
}

.product3{
    width: 107px;
    height: 68px;
}

.product4{

    width: 91px;
    height: 65px;
}

.icon{
    width: 117px;
    height: 143px;
    margin-right: 20px;
}

.icon:last-child{
    margin-right: 0px;

}

.icon_position{
    position: absolute;
    right: 6px;
    top:-60px;
}
.icon_position1{
    position: absolute;
    right: 268px;
    top:-60px;
}
.product5{
    width: 56px;
    height:112px;
}

.product6{
    width: 62px;
    height:99px;
}

.product7{
    width: 30px;
    height:94px;
}

.product8{
    width: 26px;
    height: 100px;
}
.product8{
    width: 49px;
    height: 110px;
}

.product8{
    width: 36px;
    height: 110px;
}

.margin_top_106{
    margin-top: 106px;
}
.product10{
    width: 66px;
    height: 72px;
}
.product11{
    width: 84px;
    height: 72px;
}
.product12{
    width: 55px;
    height: 81px;
}
.product13{
    width: 57px;
    height: 80px;
}

.product14{
    width: 43px;
    height: 90px;
}
.product15{
    width: 39px;
    height: 87px;
}
.product16{
    width: 42px;
    height: 98px;
}
.product17{
    width: 32px;
    height: 110px;
}

.margin_top_100{
    margin-top: 100px;
}

.margin_top_50{
    margin-top: 50px;
}

.margin_top_32{
    margin-top:32px;
}

.margin_top_20{
    margin-top: 20px;
}

.product_greenicon{
    width: 65px;
    height: 64px;
    position: absolute;
    bottom: 18px;
    right: 6px;
}
</style>
<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import { myMixin } from '@/mixin/mixin.js'
export default {
    name: 'about',
    components: {
        banner,
    },
    mixins: [myMixin],
    data() {
        return {
            productdata:[
                {
                    tap:'面膜',
                    dec:'用对面膜，自带美颜',
                    destext:'美白是女人永恒的话题，美白面膜更是“c位”护肤品！能让皮肤瞬间补水，还有美白因子能让皮肤变得白嫩光滑，想要美白功效显著看小鱼的。',
                    position:'textleft',
                    firstclass:'titleleft', 
                    secondclass:'secondtitleleft',
                    product:[
                    {
                        img:'https://so.fishqc.com/activity/activityimg/618/1.jpg',
                        class:'class1',
                        efficacyimg:'https://so.fishqc.com/activity/activityimg/618/icon-white.png',
                        efficacyclass:'efficacyclass',
                        brand:'CHANDO自然堂',
                        title:'富勒烯 微导“发光”面膜', 
                        tips:'提亮修复',
                        address:'中国',
                        type:'cosmetic',
                        id:'-i2kxxcJOvpfnDaJUMtErw'

                    },{
                        img:'http://p1.fishqc.net/Fi1PB5PZzFD3A3DgdsFoM51yScI4!product.thumb',
                        class:'class2',
                        efficacyimg:'https://so.fishqc.com/activity/activityimg/618/icon-white.png',
                        efficacyclass:'efficacyclass',
                        brand:"KIEHL'S科颜氏",
                        title:"亚马逊白泥净肤面膜",
                        tips:'神奇白泥',
                        address:'美国',
                        type:'cosmetic',
                        id:'pZJBPfLrgyCPUnmj41t0fA'
                    }]
                },
                {
                    tap:'精华液',
                    dec:'护肤品中的极品，抗衰靠它们',
                    destext:'让肌肤更年轻几乎是所有女孩护肤的追求，抗衰老更是护肤中需要提前关注的重点，市面上主打抗衰老的精华液数不胜数，哪些抗衰老功效更显著，小鱼告诉你。',
                    position:'textright',
                    firstclass:'titleright', 
                    secondclass:'secondtitleright',
                    listitemclass:'border-radius-right',
                    product:[
                    {
                        img:'http://p1.fishqc.net/FhnRJGeHfrc5__m2ahCpdk9dYVP_!product.thumb',
                        class:'class3',
                        efficacyimg:'https://www.fishqc.com/image/system/icon-anti-aging-3.png',
                        efficacyclass:'efficacyclass1',
                        brand:'SHISEIDO资生堂',
                        title:'新透白美肌集光袪斑精华液',
                        tips:'口碑大牌',
                        address:'日本',
                        type:'cosmetic',
                        id:'fp6PX4zBtebjsVX7GxgoPA'

                    },{
                        img:'https://so.fishqc.com/activity/activityimg/618/3.jpg',
                        class:'class4',
                        efficacyimg:'https://www.fishqc.com/image/system/icon-anti-aging-3.png',
                        efficacyclass:'efficacyclass1',
                        brand:'LEAVYEAST东极叶',
                        title:'大麻叶修护舒缓精华液',
                        tips:'修复抗衰',
                        address:'中国',
                        type:'cosmetic',
                        id:'scL_RNqYyl2khOLBKlp_Fg'
                    }]
                },
                {
                    tap:'眼霜',
                    dec:'年不年轻看眼睛，抗衰要趁早',
                    destext:'眼睛是最容易老化并且产生问题的部位，容易出现黑眼圈、鱼尾纹、眼袋、浮肿等问题，所以预防和护理十分重要。眼霜功效哪家强，认准绿鱼放心选。',
                    position:'textleft',
                    firstclass:'titleleft', 
                    secondclass:'secondtitleleft',
                    product:[
                    {
                        img:'http://p1.fishqc.net/FsnHsj_NJrF2XDF9h2GryS3tm4f0!product.thumb',
                        class:'class5',
                        efficacyimg:'https://www.fishqc.com/image/system/icon-anti-aging-3.png',
                        efficacyclass:'efficacyclass1',
                        brand:'ESTEE LAUDER雅诗兰黛',
                        title:'白金级花菁萃紧颜焕活眼霜',
                        tips:'抗皱修护',
                        address:'美国',
                        type:'cosmetic',
                        id:'PQ-JnCji1RnGL1Z3gITE7Q'

                    },{
                        img:'http://p1.fishqc.net/FoK1SNEYQCxy3I66xQ-ctsr19EHd!product.thumb',
                        class:'class6',
                        efficacyimg:'https://www.fishqc.com/image/system/icon-anti-aging-3.png',
                        efficacyclass:'efficacyclass1',
                        brand:'FILORGA菲洛嘉',
                        title:'靓丽眼霜',
                        tips:'紧致丰盈',
                        address:'日本',
                        type:'cosmetic',
                        id:'TObaKPTsErUnekzaLvHwkg'
                    }]
                }

            ],
            productdata1:[
               
                {
                    tap:'手部护理',
                    dec:'健康和美丽全都要',
                    destext:'手是女人的第二张脸，需要好好护理。但在小鱼数据库里，达到绿鱼（品质卓越）的指甲油和护手霜竟然少之又少，怎么样才能挑到放心的产品，让双手美丽又健康，看小鱼的推荐吧。',
                    position:'textleft',
                    firstclass:'titleleft', 
                    secondclass:'secondtitleleft',
                    product:[
                    {
                        img:'http://p1.fishqc.net/FmTuXwH3ie5u_rL7UpcChOBy1d6l!product.thumb',
                        class:'class7',
                        brand:'CUREL珂润',
                        title:'润浸保湿护手霜',
                        tips:'滋润柔软',
                        address:'日本',
                        type:'cosmetic',
                        id:'5oA9jjkkPDxS_k_hkQNPhQ'

                    },{
                        img:'https://so.fishqc.com/activity/activityimg/618/2.jpg',
                        class:'class8',
                        brand:'illombo',
                        title:'水性指彩 #R01', 
                        tips:'健康指彩',
                        address:'中国',
                        type:'cosmetic',
                        id:'l6bS4FTyTJ0ypBqmE21L-g'
                    }]
                },
                {
                    tap:'保健品',
                    dec:'不交智商税，健康有保障',
                    destext:'老年人补充营养尤为重要，市面上琳琅满目的保健品该怎么选？小鱼应用三重标准测评，高效全面筛查产品安全性，绿鱼优品健康有保障。',
                    position:'textright',
                    firstclass:'titleright', 
                    secondclass:'secondtitleright',
                    listitemclass:'border-radius-right',
                    product:[
                    {
                        img:'http://p1.fishqc.net/FgstTEL4BTE6PmpPwCXeQFPFDxiV!product.thumb',
                        class:'class9',
                        brand:'SWISSE',
                        title:'ULTIBOOST 維他命 D',
                        tips:'强健骨骼',
                        address:'澳大利亚',
                        type:'food',
                        id:'wSBCwDwlva8v9AkRVIx8OQ'

                    },{
                        img:'http://p1.fishqc.net/FkGWFgnSr40znT6R45PuxlmWUkW7!product.thumb',
                        class:'class10',
                        brand:'GNC健安喜',
                        title:'高含量钙片1000mg',
                        tips:'超高钙含量',
                        address:'美国',
                        type:'food',
                        id:'yIO8Zliupd7oMIl6hXA_yg'
                    }]
                },
                {
                    tap:'纸尿裤',
                    dec:'宝宝的贴身用品，安全第一位',
                    destext:'劣质纸尿裤不仅性能差，使用感不好，更会引起皮肤炎症，过敏和感染生殖器官。为了宝宝的健康成长，认准绿鱼选择有品质保障的纸尿裤。',
                    position:'textleft',
                    firstclass:'titleleft', 
                    secondclass:'secondtitleleft',
                    product:[
                    {
                        img:'http://p1.fishqc.net/Fm9q7xaNlvHEeNoOqhZrFz3Ph-l0!product.thumb',
                        class:'class11',
                        brand:'PAMPERS帮宝适',
                        title:'超薄干爽纸尿裤S', 
                        tips:'温柔呵护',
                        address:'美国',
                        type:'cosmetic',
                        id:'l0dCWU92M7sty4sTWN7vTA'

                    },{
                        img:'http://p1.fishqc.net/FgPVMCBwSWHxcQOGipJHI55QCkre!product.thumb',
                        class:'class12',
                        brand:'HUGGIES好奇',
                        title:'天然护肤纸尿片 0号',
                        tips:'松软干爽',
                        address:'美国',
                        type:'cosmetic',
                        id:'Nu7zhpiYj597zPc21vICNQ'
                    }]
                },
                {
                    tap:'食用油',
                    dec:'生活必需品，选安全的才安心',
                    destext:'近年来，地沟油、食用油致癌物质超标事件屡屡发生，让大家闻“油”色变。食用油的选择直接影响一个家庭的健康，跟着绿鱼榜单选，更安心。',
                    position:'textright',
                    firstclass:'titleright', 
                    secondclass:'secondtitleright',
                    listitemclass:'border-radius-right',
                    product:[
                    {
                        img:'http://p1.fishqc.net/FnirSGLzq_kQhfQ4BwVtNm1VtCqb!product.thumb',
                        class:'class13',
                        brand:'BERTOLLI百得利',
                        title:'清淡橄榄油',
                        tips:'清淡健康',
                        address:'意大利',
                        type:'food',
                        id:'5c7Bbu_sv1Nuip6BY3hkqw'

                    },{
                        img:'http://p1.fishqc.net/FvABxuQ0jHHLCYLIQ2eJdnhN51JG!product.thumb',
                        class:'class14',
                        brand:'KNIFE刀唛',
                        title:'初榨橄榄芥花籽油',
                        tips:'营养丰富',
                        address:'中国香港',
                        type:'food',
                        id:'Kx8py17oya4waZRpdD4nHQ'
                    }]
                },
                {
                    tap:'大米',
                    dec:'唯有安全好米才能吃得放心',
                    destext:'民以食为天，食以洁为先，食以安为本。大米是最重要的日常主食，“镉大米”“毒大米”“假大米”频频出现，危害身体健康。给家人选安全好米，绿鱼榜单帮到你。',
                    position:'textleft',
                    firstclass:'titleleft', 
                    secondclass:'secondtitleleft',
                    product:[
                    {
                        img:'http://p1.fishqc.net/Fms-xiI7HkesFOSV-WtdCRRqVXMh!product.thumb',
                        class:'class15',
                        brand:'ARAWANA金龙鱼',
                        title:'盘锦大米',
                        tips:'柔韧细腻',
                        address:'中国',
                        type:'food',
                        id:'1-DuLoodOV9JeSeRuVFiNQ'

                    },{
                        img:'http://p1.fishqc.net/FqCgiAMFgxeCa1gDz9A4MqTDQCx5!product.thumb',
                        class:'class16',
                        brand:'AKITAKOMACHI秋田',
                        title:'珍珠米',
                        tips:'香甜软糯',
                        address:'日本',
                        type:'food',
                        id:'p9ub8TaoQCB-ZKyGN0EKNw'
                    }]
                },
                {
                    tap:'狗粮',
                    dec:'安全健康才是好狗粮',
                    destext:'劣质狗粮会加重保鲜剂、香精等添加剂的用料，影响消化系统，长期食用容易有慢性疾病，肠胃炎等，严重时还会危害生命。认准绿鱼优品，不怕掉坑。',
                    position:'textright',
                    firstclass:'titleright', 
                    secondclass:'secondtitleright',
                    listitemclass:'border-radius-right',
                    product:[
                    {
                        img:'http://p1.fishqc.net/FpDGqxfVNQbgMRDDWAPfDIuWDcYX!product.thumb',
                        class:'class17',
                        brand:"HILL'S希尔思",
                        title:'Ideal Balance天然配方成犬鸡肉及糙米成犬狗粮',
                        tips:'天然食材',
                        address:'美国',
                        type:'food',
                        id:'BSV9vVKWR82glmzGLWihmw'

                    },{
                        img:'http://p1.fishqc.net/FsP81QmdlndT2ZGQNNAAJDHE-PZB!product.thumb',
                        class:'class18',
                        brand:'CANIDAE卡比',
                        title:'鸡肉红米配方狗粮',
                        tips:'高蛋白易消化',
                        address:'美国',
                        type:'food',
                        id:'OyDIUeIxR3P7ojLBFuxbKA'
                    }]
                }

            ],
            imgarr:['https://product.fishqc.com/img/activity/618/tech.png','https://product.fishqc.com/img/activity/618/tech-white.png','https://product.fishqc.com/img/activity/618/tech-kangyang.png'],
        }

    },
    computed: {
        swiper() {
            return this.$refs.order_report_Swiper.$swiper
        }
    },
    mounted() {
        // var position  =  this.$route.query.position
        // this.scrollTo(position)
        this.currentlang = window.localStorage.getItem("LOCALE") || 'chs'
    },
    methods: {
        scrollTo(position) {
            var that = this;
            var scroll_H;
            this.$nextTick(function() {
                if (position == 'greenrank') {
                    var d = document.getElementById("greenrank");
                    var topPos = d.offsetTop;
                    scroll_H = topPos - 110; //减去header高度
                } else {
                    scroll_H = this.$refs[position].offsetTop - 110; //减去header高度
                }
                //全局方法
                that.scrollToY(scroll_H, 1500, 'easeInOutQuint');
            })
        },
        toproductdetail(type,prdid){
            this.$router.push({
                path: '/product/'+type+'/'+prdid
            })
            
        }
    }
}
</script>